import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Select from "../../../components/ui/Select";
import { Checkbox } from "../../../components/ui/Checkbox";
import { useTranslation } from 'react-i18next';

const OrderNotes = ({ onNotesChange }) => {
  const { t } = useTranslation();
  
  const [notes, setNotes] = useState("");
  const [deliveryInstructions, setDeliveryInstructions] = useState("");
  const [preferredDeliveryTime, setPreferredDeliveryTime] = useState("");
  const [giftMessage, setGiftMessage] = useState("");
  const [isGift, setIsGift] = useState(false);
  const [specialRequests, setSpecialRequests] = useState([]);

  const deliveryTimeOptions = [
    { value: "", label: t('noPreference') },
    { value: "morning", label: t('morningTime') },
    { value: "afternoon", label: t('afternoonTime') },
    { value: "evening", label: t('eveningTime') },
    { value: "weekend", label: t('weekendOnly') },
    { value: "weekday", label: t('weekdayOnly') },
  ];

  const specialRequestOptions = [
    { id: "fragile", label: t('handleFragile') },
    { id: "signature", label: t('requireSignature') },
    { id: "doorstep", label: t('leaveAtDoorstep') },
    { id: "neighbor", label: t('deliverToNeighbor') },
    { id: "call", label: t('callBeforeDelivery') },
    { id: "text", label: t('sendTextUpdates') },
  ];

  useEffect(() => {
    if (onNotesChange) {
      onNotesChange({
        notes,
        deliveryInstructions,
        preferredDeliveryTime,
        giftMessage: isGift ? giftMessage : "",
        isGift,
        specialRequests,
      });
    }
  }, [
    notes,
    deliveryInstructions,
    preferredDeliveryTime,
    giftMessage,
    isGift,
    specialRequests,
    onNotesChange,
  ]);

  const handleNotesChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setNotes(value);
    }
  };

  const handleDeliveryInstructionsChange = (e) => {
    const value = e.target.value;
    if (value.length <= 300) {
      setDeliveryInstructions(value);
    }
  };

  const handleGiftMessageChange = (e) => {
    const value = e.target.value;
    if (value.length <= 200) {
      setGiftMessage(value);
    }
  };

  const handleSpecialRequestChange = (requestId, checked) => {
    if (checked) {
      setSpecialRequests((prev) => [...prev, requestId]);
    } else {
      setSpecialRequests((prev) => prev.filter((id) => id !== requestId));
    }
  };

  const handleGiftToggle = (e) => {
    setIsGift(e.target.checked);
    if (!e.target.checked) {
      setGiftMessage("");
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-2">
        <Icon name="MessageSquare" size={20} className="text-primary" />
        <h2 className="text-xl font-semibold text-text-primary">
          {t('orderNotesInstructions')}
        </h2>
      </div>

      {/* General Order Notes */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-text-primary">
          {t('orderNotes')}
        </label>
        <textarea
          value={notes}
          onChange={handleNotesChange}
          placeholder={t('orderNotesPlaceholder')}
          className="w-full min-h-[100px] px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-vertical text-text-primary bg-input"
          maxLength={500}
        />
        <div className="flex justify-between text-xs text-text-secondary">
          <span>{t('optionalNotes')}</span>
          <span>{notes.length}/500</span>
        </div>
      </div>



    </div>
  );
};

export default OrderNotes;
